var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVControlMuted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.867 19.978A5 5 0 0021.09 15.5v2.456l2.723 2.722c.033-.223.055-.456.055-.7zm2.778 0a7.605 7.605 0 01-.6 2.933l1.678 1.678a9.773 9.773 0 001.144-4.611 9.974 9.974 0 00-7.778-9.734v2.278a7.783 7.783 0 015.556 7.456zm-16.367-10l-1.41 1.4 5.244 5.255H8.867V23.3h4.445l5.555 5.555v-7.477L23.59 26.1a7.693 7.693 0 01-2.5 1.311V29.7a9.988 9.988 0 004.1-2.011l2.267 2.278 1.411-1.412-10-10-8.578-8.577h-.01zm8.578 1.1l-2.322 2.31 2.322 2.323v-4.633z",
    fill: "#fff"
  })));
}

export default SvgVControlMuted;